import Select from 'react-select';
import React, {useCallback} from 'react';
import _ from 'lodash';
import {getReactSelectDefaultProps} from 'config/react-select';
import {evoAppsUserToSerialID, filterOptions, parseEvoAppsUserSerialID} from 'module/SessionInfo/util/SwitchUserUtil';
import {switchUserHandler} from 'module/SessionInfo/api/SwitchUserAPI';
import {EvoAppsUserLabel} from 'module/SessionInfo/component/userInfo/EvoAppsUserLabel';
import {EvoAppsUserTO, EvoAppsUserWrapperTO} from 'generated/JavaTO';


const mapToSelectValue = (user: EvoAppsUserTO, defaultEvoAppsUser: EvoAppsUserTO) => ({
	value: evoAppsUserToSerialID(user, defaultEvoAppsUser),
	label: <EvoAppsUserLabel user={user} defaultUser={defaultEvoAppsUser}/>,
});

export const SwitchUserComponent = React.memo<{ evoAppsUser: EvoAppsUserWrapperTO }>(({evoAppsUser}) => {
	const {alternativeUsers, defaultEvoAppsUser} = evoAppsUser || {};
	const disabled = _.isEmpty(alternativeUsers);
	const value = evoAppsUser && mapToSelectValue(evoAppsUser, defaultEvoAppsUser) || null;
	const options = [
		defaultEvoAppsUser,
		...alternativeUsers,
	].map(u => mapToSelectValue(u, defaultEvoAppsUser));
	return (
		<Select {...getReactSelectDefaultProps({
			isDisabled: disabled,
			value: value,
			options: options,
			filterOption: useCallback((option, inputValue) => filterOptions(option, inputValue), []),
			onChange: useCallback(u => switchUserHandler(parseEvoAppsUserSerialID(u.value)), []),
		})}/>
	);
});